export default __webpack_public_path__ + "static/media/Proxitor-40.26ca2cb0.jpg";